const formatDate = (date: Date) =>
  date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
const formatDateTime = (date: Date) =>
  date.toLocaleTimeString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });

export { formatDate, formatDateTime };
